import { AvailabilityStateInterface } from '.';

function state(): AvailabilityStateInterface {
  return {
    availability: [],
  };
}

export default state;
